import MainLayout from 'components/templates/MainLayout';

const Users = () => {
	return <MainLayout url="users"></MainLayout>;
};

export default Users;
